// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryDirectory_root__SiR6m","heading":"CategoryDirectory_heading__o2VY6","scroller":"CategoryDirectory_scroller__Oo218"};